var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M0-682.665H20v20H0Z",
    transform: "translate(0 682.665)",
    fill: "#7b818e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line_Outline",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2405",
    "data-name": "Group 2405",
    transform: "translate(0 0.002)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M-11.855-152.02c-.182,0-.358-.088-.358-.257v-4.08c0-.176.2-.251.408-.251s.408.075.408.251v3.621h1.531c.163,0,.245.176.245.358s-.082.358-.245.358Z",
    transform: "translate(16.294 162.973)",
    fill: "#7b818e",
    stroke: "#707070",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M-11.855-152.02c-.182,0-.358-.088-.358-.257v-4.08c0-.176.2-.251.408-.251s.408.075.408.251v3.621h1.531c.163,0,.245.176.245.358s-.082.358-.245.358Z",
    transform: "translate(16.294 162.973)",
    fill: "none",
    stroke: "#7b818e",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M0-8.322c0-.176.2-.251.408-.251s.408.075.408.251v4.08c0,.169-.207.257-.408.257S0-4.073,0-4.242Z",
    transform: "translate(7.313 14.939)",
    fill: "#7b818e",
    stroke: "#707070",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M0-8.322c0-.176.2-.251.408-.251s.408.075.408.251v4.08c0,.169-.207.257-.408.257S0-4.073,0-4.242Z",
    transform: "translate(7.313 14.939)",
    fill: "none",
    stroke: "#7b818e",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M-71.746-143.494l-1.349-2.523v2.523c0,.169-.207.257-.408.257s-.408-.088-.408-.257v-4.073c0-.176.2-.257.408-.257.295,0,.414.063.609.433l1.211,2.341v-2.523c0-.176.2-.251.408-.251s.408.075.408.251v4.08c0,.169-.207.257-.408.257a.49.49,0,0,1-.471-.257",
    transform: "translate(82.99 154.19)",
    fill: "#7b818e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M-71.746-143.494l-1.349-2.523v2.523c0,.169-.207.257-.408.257s-.408-.088-.408-.257v-4.073c0-.176.2-.257.408-.257.295,0,.414.063.609.433l1.211,2.341v-2.523c0-.176.2-.251.408-.251s.408.075.408.251v4.08c0,.169-.207.257-.408.257A.49.49,0,0,1-71.746-143.494Z",
    transform: "translate(82.99 154.19)",
    fill: "none",
    stroke: "#7b818e",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M-27.036-65.3h.954c.163,0,.257.157.257.326a.284.284,0,0,1-.257.314h-.954V-63.4h1.776c.163,0,.257.169.257.364,0,.17-.082.352-.257.352h-2.234c-.182,0-.358-.088-.358-.257v-4.073c0-.17.176-.257.358-.257h2.234c.176,0,.257.182.257.352,0,.194-.094.364-.257.364h-1.776Z",
    transform: "translate(40.922 73.636)",
    fill: "#7b818e",
    stroke: "#707070",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M-27.036-65.3h.954c.163,0,.257.157.257.326a.284.284,0,0,1-.257.314h-.954V-63.4h1.776c.163,0,.257.169.257.364,0,.17-.082.352-.257.352h-2.234c-.182,0-.358-.088-.358-.257v-4.073c0-.17.176-.257.358-.257h2.234c.176,0,.257.182.257.352,0,.194-.094.364-.257.364h-1.776Z",
    transform: "translate(40.922 73.636)",
    fill: "none",
    stroke: "#7b818e",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M-311.918,0c-5.2,0-9.414,3.421-9.414,7.641,0,3.986,3.76,7.257,8.558,7.608v2.714c1.549,0,10.27-4.31,10.27-10.322C-302.5,3.421-306.719,0-311.918,0Z",
    transform: "translate(321.918 1.019)",
    fill: "none",
    stroke: "#7b818e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.6c91f7739eeb3364b49c593f54c5bf7f.svg";
export { ForwardRef as ReactComponent };